/**
 * Risolve operatore RENTRI (num_iscr) e unità locale a partire dal CF/P.IVA,
 * selezionando automaticamente il primo sito se non ancora impostato.
 */
import { endpoints } from "@/api/client";
import type { OperatoreContextValue } from "@/lib/operatoreContext";

function sitoId(s: Record<string, unknown>): string {
  return String(s.num_iscr_sito ?? s.identificativo ?? s.id ?? "");
}

function sitoLabel(s: Record<string, unknown>, id: string): string {
  return String(s.denominazione ?? s.nome ?? id);
}

export async function bootstrapOperatoreContext(
  ctx: Pick<
    OperatoreContextValue,
    "cf" | "numIscr" | "numIscrSito" | "setCf" | "setOperatore" | "setSito"
  >,
  cfOverride?: string,
): Promise<{ ok: boolean; missing?: "cf" | "operatore" | "sito" }> {
  const cf = (cfOverride ?? ctx.cf).trim().replace(/\s/g, "");
  if (cf.length < 11) {
    return { ok: false, missing: "cf" };
  }
  if (ctx.cf !== cf) {
    ctx.setCf(cf);
  }

  let numIscr = ctx.numIscr.trim();
  let denominazione = "";

  if (!numIscr) {
    const rows = await endpoints.anagrafiche.operatori(cf);
    const op = (Array.isArray(rows) ? rows[0] : undefined) as
      | { num_iscr?: string; denominazione?: string }
      | undefined;
    numIscr = op?.num_iscr?.trim() ?? "";
    denominazione = op?.denominazione?.trim() ?? "";
    if (numIscr) {
      ctx.setOperatore(numIscr, denominazione);
    }
  }

  if (!numIscr) {
    return { ok: false, missing: "operatore" };
  }

  if (ctx.numIscrSito.trim()) {
    return { ok: true };
  }

  const sitiRaw = await endpoints.anagrafiche.siti(numIscr);
  const siti = (Array.isArray(sitiRaw) ? sitiRaw : []) as Record<string, unknown>[];
  if (siti.length === 0) {
    return { ok: false, missing: "sito" };
  }

  const first = siti[0];
  const id = sitoId(first);
  if (!id) {
    return { ok: false, missing: "sito" };
  }
  ctx.setSito(id, sitoLabel(first, id));
  return { ok: true };
}
